<div class="oopsOuter">
    <div class="oops ColorBlue">OOPS!</div>
    <div class="error ColorRed">AUTHENTICATION FAILED</div>
</div>
